import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import $ from "jquery";
import { useEffect, useState } from "react";
import { actionPolicyUpdate, resetUpdatePolicy } from "../../routes/app/auth/policies/store";
import { actionUploadClaimDoc, resetUploadClaimResponse } from "../../routes/app/auth/claim/store";
import { useDispatch, useSelector } from "react-redux";
import {
  TOAST_DURATION,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";
import toast from "react-hot-toast";


const RcUpload_Document = (props) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    setError,
    reset
  } = useForm({
    defaultValues: {
      documents: null,
    },
  });
  const [showEmail, setShowEmail] = useState(false);
  const dispatch = useDispatch();
  const { updatePolicy } = useSelector((state) => ({
    ...state.policyStore,
  }));
  const { uploadClaimDoc } = useSelector((state) => ({
    ...state.claimStore,
  }));
  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
    }
  };
  useEffect(initialRender, [props.show]);


  useEffect(() => {
    if (updatePolicy) {
      dispatch(resetUpdatePolicy());
      if (updatePolicy.status) {
        setShowEmail(false)
        if (showEmail) {
          props.handleClose();
          window.location.reload()
          toast.success(updatePolicy.message, {
            duration: TOAST_DURATION,
            position: TOAST_POSITION,
            style: {
              color: TOAST_SUCCESS_COLOR,
            },
          });
        }
      } else {
        props.handleClose();
        switch (updatePolicy.status_code) {
        }
      }
    }
  }, [updatePolicy]);

  useEffect(() => {
    if (uploadClaimDoc !== null) {
      dispatch(resetUploadClaimResponse());
      if (uploadClaimDoc.status === true) {
        toast.success(uploadClaimDoc.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        $("#app-body").removeClass("modal-open");
        $(".modal-backdrop").remove();
        setValue("documents", null);
        props.handleClose();
        window.location.reload();
      } else {
        props.handleClose();
        switch (uploadClaimDoc.status_code) {
        }
      }
    }
  }, [uploadClaimDoc]);

  const onSubmit = (data) => {
    setShowEmail(true);
    // Valid document types
    const validTypes = ['application/pdf'];

    // Check if the uploaded document is valid
    if (!data.documents || !validTypes.includes(data.documents[0].type)) {
      setError('documents', {
        message: 'Please select a valid document format',
        type: 'manual'
      }, {
        shouldFocus: true
      })
      return;
    }
    // Set common properties for both actions
    var input = {
      policy_id: props.policyObj?.id,
      rc_no: data.vehicle_no
    }
    // Prepare files for actionUploadClaimDoc
    var files = [];
    if (data.documents != null) {
      files.push({
        name: "file",
        value: data.documents[0],
      });
    }
    // dispatch(actionUploadClaimDoc({ data, files }));
    dispatch(actionPolicyUpdate({ files, input }));
  };

  return (
    <div
      className="modal fade show"
      id="uploadDocument"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ display: `${props.show === true ? "block" : "none"}` }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <div className="modal-content">
            <div className="modal-body ">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Upload Documents
                </h5>
                <div>

                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setValue("documents", null);
                      props.handleClose();

                    }}></button>

                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="vehicleNo" className="form-label">
                    Vehicle Number
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="vehicle_no"
                    {...register("vehicle_no", {
                      required: "This is required",
                      pattern: {
                        value: /^[A-Za-z0-9]{10}$/,
                        message: "Please enter a valid vehicle number with 10 characters.",
                      },
                    })}
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.vehicle_no && (
                    <ErrorLabel message={errors?.vehicle_no?.message} />
                  )}
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="formFile" className="form-label">
                    RC Upload<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    accept=".pdf"
                    name="documents"
                    {...register("documents", {
                      required: "This is required.",
                      validate: {
                        lessThan20MB: (files) =>
                          files[0]?.size <= 21971520 || "Max size for file 20MB",
                        // acceptedFormats: (files) =>
                        //     ["image/jpg", "image/png", "image/gif"].includes(
                        //         files[0]?.type
                        //     ) || "only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images allowed."
                      },
                    })}
                  />
                  {errors.documents && (
                    <ErrorLabel message={errors.documents?.message} />
                  )}
                </div>
                <div className="col-12 mt-3">
                  <small className="fs-7">Only pdf allowed.
                    Max size for file 20MB
                  </small>
                </div>
              </div>
              <div className="form-actions border-0 float-none mt-1">
                <button type="submit" className="btn btn-primary btn-sm mt-3">
                  Submit
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm shadow rounded text-uppercase mt-3 ms-2"
                  onClick={(event) => {
                    props.handleClose();
                    event.preventDefault();
                  }}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RcUpload_Document;
